import type { Table } from "@tanstack/react-table";
import type { ICliente } from "../../../modelos/Clientes/entidades/ICliente";
import type { IProyecto } from "../../../modelos/Proyectos/entidades/IProyecto";
import type { IContactoCliente } from "../../../modelos/Clientes/entidades/IContactoCliente";
import type { IClienteHistorial } from "../../../modelos/ClientesContratos/entidades/IClienteHistorial";
import type { IFiltroCliente } from "../../../modelos/Clientes/entidades/IFiltroCliente";
import dayjs from "dayjs";

export interface ITablaClientesVistaProps {
    tabla: Table<IClienteHistorial>;
    maxHeight?: number;
    consultarClientes: (page: number, size: number) => Promise<void>;
      filtro: IFiltroCliente;
    // consultarClientes: () => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    manejarCambioFiltroCliente: (campo: keyof IFiltroCliente, valor: IFiltroCliente[keyof IFiltroCliente]) => void;
    indicePagina: number;
    TAMANIO_PAGINA: number;
}

export const estadoInicialCliente: ICliente = {
    Id: 0,
    Nombre: "",
    TipoIdentificacionId: 0,
    TipoIdentificacionNombre: "",
    Identificacion: "",
    RazonSocial: "",
    Activo: true,
    Eliminado: false,
    CreadoUtc: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    ActualizadoUtc: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    ContactoClientes: [
        {
            ClienteId: 0,
            Email: '',
            EsPrincipal: true,
            Id: 0,
            Nombre: '',
            Telefono: ''
        },
        {
            ClienteId: 0,
            Email: '',
            EsPrincipal: false,
            Id: 0,
            Nombre: '',
            Telefono: ''
        }
    ]
    // NombreContacto1: "",
    // TelefonoContacto1: "",
    // EmailContacto1: "",
    // NombreContacto2: "",
    // TelefonoContacto2: "",
    // EmailContacto2: ""
};

export interface ITipoIdentificacion {
    IdTipoIdentificacion: number;
    TipoIdentificacion: string;
    Activo: boolean;
}

export interface IFormularioClienteVistaProps {
    clienteSeleccionado: ICliente;
    manejarCambioValorCliente: (campo: keyof ICliente, valor: ICliente[keyof ICliente]) => void;
    agregarEditarCliente: () => void;
    tiposIdentificacion: ITipoIdentificacion[];
    agregarError: (campo: keyof ICliente, error: string) => Promise<void>;
    errores: Partial<Record<keyof ICliente, string | null>>;
    renovarCliente: (estado: boolean) => void;
    enRenovacionCliente: boolean;
    proyecto: IProyecto;
    consultarClientePorIdentificacion: (identificacion: string) => Promise<void>;
    clienteConsultadoIdentificacion: boolean;
    limpiarCampos: () => void;
    agregarErrorContacto: (posicion: number, campo: keyof IContactoCliente, error: string) => void;
    erroresContactos: Record<number, Partial<Record<keyof IContactoCliente, string | null>>>;
    consultarClienteActivo: (clienteId: number) => Promise<void>;
}

export interface IClientesCVProps {
    pantallaCompleta: boolean;
    // setCargandoModal: React.Dispatch<React.SetStateAction<boolean>>
}

export interface IFiltroClientesVistaProps {
    filtro: IFiltroCliente;
    consultarClientes: () => void;
    manejarCambioFiltroCliente: (campo: keyof IFiltroCliente, valor: IFiltroCliente[keyof IFiltroCliente]) => void;
}

export const estadoInicialFiltroCliente: IFiltroCliente = {
    Id: 0,
    Nombre: "",
    Identificacion: "",
    RazonSocial: "",
    Page: 0,    
    Size: 0
};